import {
  Globe,
  Code2,
  Bot,
  BarChart3,
  Workflow,
  Database,
  Zap,
  Plug,
  type LucideIcon,
} from "lucide-react";

export type Servico = {
  slug: string;
  titulo: string;
  tagline: string;
  icon: LucideIcon;
  preco: string;
  precoDestaque: string;
  entregamos: string[];
  diferenciais: string[];
  indicado: string[];
};

export const servicos: Servico[] = [
  {
    slug: "webdesign",
    titulo: "Webdesign e Criação de Sites",
    tagline:
      "Sites institucionais, Landing Pages profissionais e otimizadas para o Google.",
    icon: Globe,
    preco: "R$ 1.500",
    precoDestaque: "A partir de R$ 1.500",
    entregamos: [
      "Site institucional ou landing page responsiva",
      "Design moderno alinhado à sua identidade visual",
      "Otimização SEO on-page (Google Ready)",
      "Integração com WhatsApp, formulários e analytics",
      "Publicação, domínio e suporte inicial",
    ],
    diferenciais: [
      "Performance Lighthouse 90+",
      "Acessibilidade e boas práticas de UX",
      "Hospedagem moderna em borda (edge)",
      "Código limpo, escalável e manutenível",
    ],
    indicado: [
      "Empresas que precisam de presença digital profissional",
      "Profissionais autônomos e clínicas",
      "Negócios locais que querem ranquear no Google",
    ],
  },
  {
    slug: "sistemas-web",
    titulo: "Criação de Sistemas Web (SaaS)",
    tagline:
      "Plataformas, sistemas comerciais e automação de processos sob medida.",
    icon: Code2,
    preco: "A partir de R$ 2.000",
    precoDestaque: "A partir de R$ 2.000",
    entregamos: [
      "Sistema web sob medida (SaaS, ERP, CRM, portal)",
      "Autenticação, permissões e multi-tenant",
      "Banco de dados estruturado e seguro",
      "Painel administrativo e relatórios",
      "Deploy, monitoramento e manutenção",
    ],
    diferenciais: [
      "Arquitetura escalável (React + Postgres)",
      "Segurança LGPD e RLS por padrão",
      "Integrações via API REST e Webhooks",
      "Time experiente em produtos reais em produção",
    ],
    indicado: [
      "Empresas que precisam digitalizar processos",
      "Startups validando um SaaS",
      "Operações que dependem de planilhas e querem profissionalizar",
    ],
  },
  {
    slug: "chatbots",
    titulo: "Chatbots Inteligentes",
    tagline:
      "Assistentes virtuais automatizados integrados para sites e fluxos de atendimento.",
    icon: Bot,
    preco: "R$ 1.500",
    precoDestaque: "A partir de R$ 1.500",
    entregamos: [
      "Chatbot integrado ao site e/ou WhatsApp",
      "Fluxos de atendimento personalizados",
      "Integração com IA (LLMs) para respostas inteligentes",
      "Transferência para atendimento humano",
      "Painel de métricas e conversas",
    ],
    diferenciais: [
      "IA contextual treinada com seus documentos",
      "Multi-canal (Web, WhatsApp, Instagram)",
      "Redução de até 70% no tempo de atendimento",
      "Implantação rápida em poucos dias",
    ],
    indicado: [
      "E-commerces e serviços com alto volume de dúvidas",
      "Empresas com SAC ou suporte recorrente",
      "Times comerciais que precisam qualificar leads 24/7",
    ],
  },
  {
    slug: "power-bi",
    titulo: "Dashboards em Power BI",
    tagline:
      "BI avançado, relatórios gerenciais e inteligência de negócios para tomada de decisão.",
    icon: BarChart3,
    preco: "Sob Consulta",
    precoDestaque: "Orçamento Personalizado baseado no escopo",
    entregamos: [
      "Dashboards interativos em Power BI",
      "Modelagem de dados e DAX otimizado",
      "Conexão com suas fontes (SQL, Excel, APIs)",
      "Atualização automática agendada",
      "Treinamento da equipe para uso",
    ],
    diferenciais: [
      "Visualizações claras e focadas em decisão",
      "Modelo estrela e performance otimizada",
      "Governança de dados e segurança de linha (RLS)",
      "Storytelling de dados aplicado ao negócio",
    ],
    indicado: [
      "Diretores e gerentes que precisam de visão consolidada",
      "Empresas com múltiplas fontes de dados",
      "Equipes financeiras, comerciais e operacionais",
    ],
  },
  {
    slug: "etl",
    titulo: "Criação e Automação de ETL",
    tagline:
      "Integração, tratamento e pipelines automatizados de dados entre sistemas.",
    icon: Workflow,
    preco: "Sob Consulta",
    precoDestaque: "Orçamento Personalizado baseado no escopo",
    entregamos: [
      "Pipelines ETL/ELT robustos e monitorados",
      "Integração entre múltiplas fontes (ERPs, APIs, planilhas)",
      "Tratamento, limpeza e padronização de dados",
      "Cargas incrementais e agendamentos",
      "Documentação técnica e logs de execução",
    ],
    diferenciais: [
      "Stack moderno (Python, Airflow, dbt, SQL)",
      "Alta confiabilidade e alertas de falha",
      "Reprocessamento e versionamento de dados",
      "Padrão Data Lake / Data Warehouse",
    ],
    indicado: [
      "Times de dados e BI que precisam de fundação sólida",
      "Empresas que integram vários sistemas",
      "Operações que sofrem com dados inconsistentes",
    ],
  },
  {
    slug: "dba",
    titulo: "Administração de Banco de Dados (DBA)",
    tagline:
      "Otimização de performance, tuning de queries, segurança e backup (PostgreSQL / Oracle).",
    icon: Database,
    preco: "Sob Consulta",
    precoDestaque: "Orçamento Personalizado baseado no escopo",
    entregamos: [
      "Tuning de queries e índices",
      "Monitoramento de performance e alertas",
      "Política de backup e disaster recovery",
      "Hardening de segurança e auditoria",
      "Migrações entre bancos e versões",
    ],
    diferenciais: [
      "Experiência em PostgreSQL, Oracle e Supabase",
      "Boas práticas de alta disponibilidade",
      "Redução comprovada de custo de infraestrutura",
      "Atendimento sob SLA",
    ],
    indicado: [
      "Empresas com bancos críticos em produção",
      "Sistemas com lentidão ou gargalos",
      "Times sem DBA dedicado interno",
    ],
  },
  {
    slug: "automacao",
    titulo: "Automação de Processos Integrados",
    tagline:
      "Elimine tarefas manuais repetitivas. Interligue seus sistemas (CRM, ERP, WhatsApp, Planilhas) com fluxos automatizados que rodam sozinhos 24/7.",
    icon: Zap,
    preco: "A partir de R$ 1.800",
    precoDestaque: "A partir de R$ 1.800 ou manutenção mensal",
    entregamos: [
      "Mapeamento dos processos manuais atuais",
      "Fluxos de automação em n8n e/ou scripts sob medida",
      "Integração com CRM, ERP, WhatsApp, Planilhas e APIs",
      "Notificações, alertas e relatórios automáticos",
      "Monitoramento, logs e tratamento de falhas",
    ],
    diferenciais: [
      "Stack moderna (n8n self-hosted, Node.js, Python)",
      "Execução 24/7 com retry e observabilidade",
      "Reduz horas operacionais e erros humanos",
      "Modelo de manutenção mensal com SLA",
    ],
    indicado: [
      "Equipes que perdem horas copiando dados entre sistemas",
      "Comerciais que enviam relatórios e follow-ups manuais",
      "Operações que dependem de planilhas e e-mails recorrentes",
    ],
  },
  {
    slug: "integracoes",
    titulo: "Integrações por API",
    tagline:
      "Conecte a ItaCondo ou qualquer outro sistema às ferramentas que sua operação já utiliza via API REST e Webhooks.",
    icon: Plug,
    preco: "Sob Consulta",
    precoDestaque: "Orçamento Personalizado baseado no escopo",
    entregamos: [
      "Mapeamento e modelagem de integrações",
      "Desenvolvimento de conectores de API REST/GraphQL",
      "Webhooks para sincronização em tempo real",
      "Autenticação segura (OAuth, Chaves de API)",
      "Documentação técnica e painel de monitoramento",
    ],
    diferenciais: [
      "Arquitetura serverless de alta disponibilidade",
      "Tratamento automático de falhas e retentativas",
      "Segurança e criptografia ponta a ponta",
      "Monitoramento ativo e alertas automáticos",
    ],
    indicado: [
      "Empresas que usam sistemas legados e querem conectá-los",
      "Operações que precisam integrar CRM, ERP e plataformas de pagamento",
      "Condomínios que querem integrar controle de acesso à contabilidade",
    ],
  },
];

export const getServicoBySlug = (slug?: string) =>
  servicos.find((s) => s.slug === slug);